import React from 'react';
import { Stack, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TranslationSearch from './TranslationSearch';
import SubmitTranslation from './SubmitTranslation';
import TranslationFilters from './TranslationFilters';
import Access from './Access';
import { UserRole } from '../types/userProfile';

const ALLOWED_ROLES_FOR_SUBMIT: UserRole[] = [UserRole.Admin, UserRole.Contributor];

const TranslationHeader: React.FC = () => {
    const navigate = useNavigate();

    const handleSubmitTranslation = () => {
        navigate('/addtranslation');
    };

    return (
        <Stack sx={styles.translationHeader} direction={{ xs: 'column', md: 'row' }} spacing={2} >
          <TranslationFilters />
          <Access roles={ALLOWED_ROLES_FOR_SUBMIT}>
            <SubmitTranslation onSubmit={handleSubmitTranslation} />
          </Access>
          <TranslationSearch />
        </Stack>
    );
};

const styles = {
    translationHeader: {
        alignItems: 'center',
        p: 2,
        flexShrink: 0, // Don't allow header to shrink
    },
};

export default TranslationHeader;
